import { render } from "./CoverImageCropper.vue?vue&type=template&id=1b46b6e5&scoped=true"
import script from "./CoverImageCropper.vue?vue&type=script&lang=js"
export * from "./CoverImageCropper.vue?vue&type=script&lang=js"

import "./CoverImageCropper.vue?vue&type=style&index=0&id=1b46b6e5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b46b6e5"]])

export default __exports__